import { useTranslation } from 'react-i18next';
import { formatDateTime } from '../../common/formatHelper';
import useFormatter from '../../common/useFormatter';
import { ColumnConfig } from '../../components/DatasetTable';
import Tag from '../../helpContext/Tag';
import ActualityEntityTag from '../components/ActualityIEntityTag';
import { ActualityJob } from '../store/actuality.types';

function useActualityJobsTableConfig(): ColumnConfig<ActualityJob>[] {
  const { t } = useTranslation('dataset');
  const formatter = useFormatter();

  const columnsConfig: ColumnConfig<ActualityJob>[] = [
    {
      field: 'jobId',
      title: t`Job Id`,
      hasFilter: true,
      render: (jobId: string, row) => (
        <ActualityEntityTag
          entity="job"
          title={jobId}
          filters={{ agentId: row['agentId'], jobId }}
        />
      ),
    },
    {
      field: 'minEventTime',
      title: 'Started',
      hasFilter: true,
      hasSort: true,
      render: (v: Date) => formatDateTime(v),
    },
    {
      field: 'maxEventTime',
      title: 'Ended',
      hasFilter: true,
      hasSort: true,
      render: (v: Date) => formatDateTime(v),
    },

    // {
    //   field: 'minPreviousEndTime',
    //   title: 'Previous',
    //   hasFilter: true,
    //   hasSort: true,
    //   render: (v: Date | null | undefined) => {
    //     return v ? formatDateTime(v) : '-';
    //   },
    // },

    {
      field: 'agentId',
      title: t`Agent`,
      hasSort: true,
      hasFilter: true,
      render: (agentId: string) => (
        <ActualityEntityTag
          entity="agentId"
          title={agentId}
          filters={{ agentId }}
        />
      ),
    },

    {
      field: 'eventProcessType',
      title: 'Process Type',
      hasFilter: true,
      hasSort: true,
      render: (field: string) => <Tag className="text-xxs">{field}</Tag>,
    },
    {
      field: 'uomCount',
      title: t`UOM count`,
      hasSort: true,
    },
    {
      field: 'eventsCount',
      title: t`Lines`,
    },

    {
      field: 'analyzedDuration',
      title: t`duration`,
      hasFilter: true,
      render: (v: number) => formatter.formatTimeSpan(v).fullString,
    },
    {
      field: 'analyzedCost',
      title: t`Cost`,
      hasFilter: true,
      render: (v: number) => formatter.formatCurrency(v).fullString,
    },
    {
      field: 'analyzedDistance',
      title: t`Distance`,
      hasFilter: true,
      render: (v: number) => (v ? formatter.formatDistance(v).fullString : '-'),
    },
  ];

  return columnsConfig;
}
export default useActualityJobsTableConfig;
